// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__aISXs","left":"Virtual_left__Dgs1j","wrapper":"Virtual_wrapper__9Y+w3"};